import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  MideyeFrontChannelLogout,
  MIDEYE_FRONT_CHANNEL_LOGOUT_PATH,
} from "@mideye/auth-react";
import "@mideye/design-tokens/fonts.css";
import AppWithAuth from "./AppWithAuth.tsx";
import { api } from "./services/api";

const isFrontChannelLogoutPath =
  typeof window !== "undefined" &&
  window.location.pathname === MIDEYE_FRONT_CHANNEL_LOGOUT_PATH;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isFrontChannelLogoutPath ? (
      <MideyeFrontChannelLogout
        getConfig={api.auth.getConfig}
        configCacheKey="insight_auth_config"
      />
    ) : (
      <AppWithAuth />
    )}
  </StrictMode>,
);
